module.exports = __webpack_public_path__ + "img/doc__ko__passport.2b1afe70.png";